import {useMutation, UseMutationOptions, useQueryClient,} from '@tanstack/react-query';
import {ImportAudienceContext, ImportRequest, ImportResponse, LeadImport,} from '@tinct/core-api-models';
import {ApiError, tinctApi} from '../../api';

export type ImportAudienceLeadsParams = ImportRequest<LeadImport, ImportAudienceContext>;

export const importAudienceLeads = async (
  params: ImportAudienceLeadsParams
): Promise<ImportResponse> => {
  return await tinctApi.audiences.importLeads(params);
};

export const useImportAudienceLeads = (
  options?: Omit<
    UseMutationOptions<ImportResponse, ApiError, ImportAudienceLeadsParams>,
    'mutationFn'
  >
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: importAudienceLeads,
    onSuccess: (...args) => {
      // Invalidate audiences, leads, and campaigns queries after successful import
      // Campaigns reference audiences, so adding companies may create new pages/variants
      queryClient.invalidateQueries({ queryKey: ['audiences'] });
      queryClient.invalidateQueries({ queryKey: ['leads'] });
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign'] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
